<template>
<div class="relative dropdown-wrapper h-full"
    @mouseenter="opened = true"
    @mouseleave="opened = false">
    <span class="links-dropdown link text-base" @click.stop="opened = !opened">{{ props.title }} &#9660;</span>
    <Transition name="nav-dropdown">
        <div v-if="opened" class="dropdown-menu absolute top-full ml-4 min-w-52 h-auto overflow-hidden rounded-b-2xl px-1 py-3 flex flex-col gap-2">
            <router-link 
                v-for="([pageTitle, pageLink], index) in dropdownOptions" :key="pageLink" :to="pageLink"
                class="dropdown-item px-3 py-2 cursor-pointer"
                :style="{ '--drop-index': index }"
                @click="opened = false"
            >
                <span class="dropdown-text text-base">{{ pageTitle }}</span>
            </router-link>
        </div>
    </Transition>
</div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
interface Props {
    title: string;
    options: Record<string,  string>;
}
const props = defineProps<Props>();

const opened = ref(false);
const dropdownOptions = computed(() => Object.entries(props.options));
</script>

<style scoped>
.link,
.links-dropdown {
    text-decoration: none;
    color: #f0f7f2;
    text-shadow: 0px 0px 4px #a8c3b4;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding-left: 20px;
    padding-right: 20px;
}


.link:hover {
    color: #b0cfc2;
    text-shadow: 0px 0px 4px #6a998f;
    transform: scale(1.0375);
    transition: transform 0.5s ease;
}

.dropdown-wrapper {
    display: flex;           
    align-items: center;     
    height: 100%;
}

.dropdown-menu {
  transition: opacity 0.3s ease;
}

.dropdown-menu {
    background-color: rgba(106,153,143,.85);
    backdrop-filter: blur(12px);
    box-shadow: 0 10px 24px rgba(56, 80, 74, 0.18);
}

.nav-dropdown-enter-active,
.nav-dropdown-leave-active {
    transform-origin: top center;
    transition: opacity 0.32s ease, transform 0.32s ease;
}

.nav-dropdown-enter-from,
.nav-dropdown-leave-to {
    opacity: 0;
    transform: translateY(-10px) scaleY(0.94);
}

.nav-dropdown-enter-to,
.nav-dropdown-leave-from {
    opacity: 1;
    transform: translateY(0) scaleY(1);
}

.nav-dropdown-enter-active .dropdown-item,
.nav-dropdown-leave-active .dropdown-item {
    transition: opacity 0.24s ease, transform 0.24s ease;
    transition-delay: calc(var(--drop-index) * 55ms);
}

.nav-dropdown-enter-from .dropdown-item,
.nav-dropdown-leave-to .dropdown-item {
    opacity: 0;
    transform: translateY(-10px);
}

.nav-dropdown-enter-to .dropdown-item,
.nav-dropdown-leave-from .dropdown-item {
    opacity: 1;
    transform: translateY(0);
}

.dropdown-item {
    color: #f0f7f2;
    text-shadow: 0px 0px 4px #a8c3b4;
    background-color: rgba(106,153,143,.0);
}

.dropdown-item:hover {
    color: #e0eae6;
    text-shadow: 0px 0px 4px #96c1b8;
    background-color: rgba(121, 185, 171, 0.85);
    transition: transform 0.5s ease, color 0.5s ease, text-shadow 0.5s ease;
}

.dropdown-text {
    display: inline-block;
    transition: transform 0.5s ease, color 0.5s ease, text-shadow 0.5s ease;
}

.dropdown-item:hover .dropdown-text {
    transform: scale(1.0375);
    color: #e0eae6;
    text-shadow: 0px 0px 4px #96c1b8;
}

.relative:hover .dropdown-menu {
    display: flex;
}
</style>